'use client';
import { cn } from 'lib/utils';
import { IconButton } from 'ui';

export type CarouselNavigationProps = {
  scrollbarId: string;
  prevId: string;
  nextId: string;
  className?: string;
  prevLabel?: string;
  nextLabel?: string;
};

const CarouselNavigation = ({
  scrollbarId,
  prevId,
  nextId,
  className,
  prevLabel = 'Previous slide',
  nextLabel = 'Next slide',
}: CarouselNavigationProps) => {
  return (
    <div
      className={cn(
        'w-full flex flex-col gap-3 mt-10 pr-wrapper-page-full-x',
        className
      )}
    >
      {/* Custom Scrollbar */}
      <div
        id={scrollbarId}
        className="w-full h-0.25 bg-stone-500 [&_>_*:first-child]:h-full [&_>_*:first-child]:bg-stone-200"
      />

      {/* Custom Navigation */}
      <div className="flex justify-end items-center gap-4">
        <IconButton id={prevId} icon="carousel-arrow-left" label={prevLabel} />
        <IconButton id={nextId} icon="carousel-arrow-right" label={nextLabel} />
      </div>
    </div>
  );
};

export default CarouselNavigation;
